var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouponsIssued(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.7,
    height: 21.7,
    viewBox: "0 0 28.7 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coupon",
    transform: "translate(0.35 -2.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22324",
    "data-name": "Path 22324",
    d: "M26.833,3H1.167A1.167,1.167,0,0,0,0,4.167V10a1.167,1.167,0,0,0,1.167,1.167,2.333,2.333,0,1,1,0,4.667A1.167,1.167,0,0,0,0,17v5.833A1.167,1.167,0,0,0,1.167,24H26.833A1.167,1.167,0,0,0,28,22.833V4.167A1.167,1.167,0,0,0,26.833,3ZM25.667,21.667H2.333V18.015a4.667,4.667,0,0,0,0-9.03V5.333H25.667Z",
    transform: "translate(0)",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22325",
    "data-name": "Path 22325",
    d: "M10.167,8a1.167,1.167,0,1,0,1.167,1.167A1.167,1.167,0,0,0,10.167,8Z",
    transform: "translate(1.5 0.833)",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22326",
    "data-name": "Path 22326",
    d: "M9,6.167A1.167,1.167,0,1,0,10.167,5,1.167,1.167,0,0,0,9,6.167Z",
    transform: "translate(1.5 0.333)",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22327",
    "data-name": "Path 22327",
    d: "M10.167,11a1.167,1.167,0,1,0,1.167,1.167A1.167,1.167,0,0,0,10.167,11Z",
    transform: "translate(1.5 1.333)",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22328",
    "data-name": "Path 22328",
    d: "M10.167,14a1.167,1.167,0,1,0,1.167,1.167A1.167,1.167,0,0,0,10.167,14Z",
    transform: "translate(1.5 1.833)",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22329",
    "data-name": "Path 22329",
    d: "M11.333,18.167a1.167,1.167,0,1,0-1.167,1.167A1.167,1.167,0,0,0,11.333,18.167Z",
    transform: "translate(1.5 2.333)",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22330",
    "data-name": "Path 22330",
    d: "M14.167,9.333H20A1.167,1.167,0,0,0,20,7H14.167a1.167,1.167,0,0,0,0,2.333Z",
    transform: "translate(2.167 0.667)",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22331",
    "data-name": "Path 22331",
    d: "M14.167,13.333H20A1.167,1.167,0,0,0,20,11H14.167a1.167,1.167,0,0,0,0,2.333Z",
    transform: "translate(2.167 1.333)",
    stroke: "#fff",
    strokeWidth: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponsIssued);
export default __webpack_public_path__ + "static/media/Coupons-Issued.e09d4535e94bdfd098851a5c8705de1d.svg";
export { ForwardRef as ReactComponent };